import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

/**
 * A single image element in a masonry style image grid
 */

const GridImage = ({ key, index, left, top, photo, onClick }) => {
  const { height, width, src, alt, caption } = photo;

  const translate = (ts) => {
    const date = new Date(ts);
    return date.toString();
  };

  return (
    <ImageContainer
      key={`${key}-${index}`}
      index={index}
      onClick={(e) => {
        // console.log(index, " - ", e);
        onClick(e, { index });
      }}
      style={{ left, top, height, width }}
    >
      <OverlayContainer>
        <Image src={src} alt={alt} key={key} />
        <Caption>
          <h4>{translate(caption)}</h4>
        </Caption>
      </OverlayContainer>
    </ImageContainer>
  );
};

// GridImage.propTypes = {
//   key: PropTypes.string.isRequired,
//   index: PropTypes.number.isRequired,
//   left: PropTypes.number.isRequired,
//   top: PropTypes.number.isRequired,
//   containerHeight: PropTypes.number.isRequired,
//   onClick: PropTypes.func.isRequired,
//   photo: PropTypes.shape({
//     alt: PropTypes.string.isRequired,
//     caption: PropTypes.string.isRequired,
//     height: PropTypes.number.isRequired,
//     width: PropTypes.number.isRequired,
//     src: PropTypes.string.isRequired
//   }).isRequired
// };

export default GridImage;

const Caption = styled.div`
  position: absolute;
  width: fit-content;
  background-color: ${({ theme }) => theme.accentColor};
  color: ${({ theme }) => theme.pageContentLinkHoverColor};
  h4 {
    text-align: center;
    margin: 0px;
    padding: 0px;
  }
  background-color: white;
  padding: 5px 10px;
  border-radius: 10px;
  margin-bottom: 20px;
`;

const OverlayContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const ImageContainer = styled.div`
  transition: border-color 0.2s linear;
  display: block;
  position: absolute;
  cursor: pointer;
  border-width: 1px;
  border-color: transparent;
  border-radius: 20px;
  &:hover {
    border-color: ${({ theme }) => theme.pageContentLinkHoverColor};
  }
  /* box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px; */
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
`;

const Image = styled.img`
  width: inherit;
  height: inherit;
  position: absolute;
  border-radius: 20px;
`;
